function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Path_706",
  x: 0,
  y: 0,
  width: 58,
  height: 70,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 0, 0)",
  filter: "url(#Path_706)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_706-2",
  "data-name": "Path 706",
  d: "M1691.884,509.025a2.977,2.977,0,0,0-1.38,2.547v31.481a2.731,2.731,0,1,1-5.461,0V511.565a3.066,3.066,0,0,0-1.456-2.588,8.2,8.2,0,0,1-3.811-6.962,8.285,8.285,0,0,1,.687-3.311l4.548,4.648,3.781-3.863-4.652-4.753a7.832,7.832,0,0,1,3.634-.893c.151,0,.3,0,.457.013a8.214,8.214,0,0,1,3.653,15.169m27.288,9.079a5.725,5.725,0,0,0,.6-2.326,3.537,3.537,0,0,0-1.1-2.569,3.426,3.426,0,0,0-2.5-1.1h-9.887a11.888,11.888,0,0,1,1.347-4.578,11.917,11.917,0,0,0,1.349-4.606,7.627,7.627,0,0,0-.9-4.162q-.9-1.348-3.595-1.349a4.786,4.786,0,0,0-1.068,2.44q-.336,1.692-.857,3.6a7.327,7.327,0,0,1-1.671,3.142q-.618.662-2.163,2.613c-.074.1-.29.383-.646.861s-.65.87-.884,1.176-.557.713-.97,1.221a16.221,16.221,0,0,1-1.124,1.262q-.5.5-1.081,1.019a4.688,4.688,0,0,1-1.124.775,2.869,2.869,0,0,1-.437.162v18.507c.1.013.208.025.325.044q.519.087.927.187t1.067.316c.441.143.768.252.984.33s.547.2,1,.358.721.263.815.3a30.465,30.465,0,0,0,9.607,2.1h3.4q5.394,0,5.394-4.793a10.091,10.091,0,0,0-.14-1.608,3.179,3.179,0,0,0,1.334-1.506,4.934,4.934,0,0,0,.491-2.11,4.042,4.042,0,0,0-.505-1.98,4.581,4.581,0,0,0,1.487-3.415,5.265,5.265,0,0,0-.279-1.593,3.907,3.907,0,0,0-.7-1.363q.9-.028,1.5-1.349m-36.095-2.325h-3.3v18.368h3.3Z",
  transform: "translate(-1670.78 -487.84)",
  fill: "#a7a8a9"
}));

function SvgRecommendedBuildsNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 70,
    viewBox: "0 0 58 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedBuildsNew);
export default __webpack_public_path__ + "static/media/recommended-builds-new.edfb1e4d.svg";
export { ForwardRef as ReactComponent };